/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface ReplaceZoneParametersPayload
 */

/**
 * Check if a given object implements the ReplaceZoneParametersPayload interface.
 */
export function instanceOfReplaceZoneParametersPayload(value) {
  return true;
}
export function ReplaceZoneParametersPayloadFromJSON(json) {
  return ReplaceZoneParametersPayloadFromJSONTyped(json, false);
}
export function ReplaceZoneParametersPayloadFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'zoneParameters': json['zoneParameters'] == null ? undefined : json['zoneParameters']
  };
}
export function ReplaceZoneParametersPayloadToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'zoneParameters': value['zoneParameters']
  };
}